<template>
  <div class="page">
    <div class="main-container">
      <div class="content">
        <div class="content-topic">
          <el-collapse v-model="activeNames">
            <el-collapse-item title="1.发现用户违规该如何举报？" name="1">
              <div class="item-content">
                <p>陌生约聊秉承给用户创造良好网络环境原则，严厉打击违法违规行为。</p>
                <p> 若您发现用户涉嫌违规，可点击对方资料页右上角更多，选择举报。陌生约聊将会在收到您举报后的2小时内尽快处理，若核实被举报用户的违规行为，将予以封禁处理。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="2.账号禁用了怎么办？" name="2">
              <div class="item-content">
                <p>账号禁用有以下几种情形:</p>
                <p>1)打广告</p>
                <p>2)留其他联系方式</p>
                <p>3)视频涉黄</p>
                <p>4)敏感词违规</p>
                <p>5)被多人举报</p>
                <p>关于账号解封问题:</p>
                <p>违规账号到系统提示的解封日期后，会自动解封</p>
                <p>还有其他疑问请在工作日联系官方在线客服咨询(服务时间8:00--17:30)</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="3.账号禁用有哪些原因？" name="3">
              <div class="item-content">
                <p>账号禁用有以下几种情形:</p>
                <p>1)色情违规传播色情内容</p>
                <p>2)以骗钱、骗金币，诈骗为目的的行为</p>
                <p>3)恶意辱骂，使用文字/图片进行攻击行为</p>
                <p>4)音视频涉黄</p>
                <p>5)敏感词违规</p>
                <p>6)被多人举报</p>
                <p>详细您可以点击<span class="blue-text" @click="handleSpanClick('userAgent')">陌生约聊平台用户行为规范</span>查看账号使用规范及相应处罚。</p>
                <p>为维护陌生约聊平台积极健康交友生态环境，保障用户合法权益及良好的用户体验，请遵守相关规定和法律法规，同时陌生约聊平台将严厉打击不良现象，对违规行为进行相应的处理。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="4.账号禁用提现的钱还能到账吗？" name="4">
              <div class="item-content">
                <p>如果账号兑换期间违规禁止提现；若账号禁用前已经提交了兑换申请或禁用期间提交了提现申请，系统都会根据账号违规情况进行判断审核，审核通过的即会正常到账，若审核不通过所兑换的积分是自动返还。后续账号解封正常使用是可以正常兑换提现的。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="5.如何注销账号？" name="5">
              <div class="item-content">
                <p>关于账号注销，请点击软件底部【我的】- 【设置】一【账号与安全】选择注销账号，提交注销后需15个工作日审核。账号注销后相关数据在注销后将清空(余额、好友等)，
                  无法登陆使用，被系统收回，并对平台其他用户开放申请，请谨慎注销。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="6.账号被禁用了还能注销吗？" name="6" class="last">
              <div class="item-content">
                <p>账号被禁用后处于冻结状态，在软件内无法搜索查询，账号资料信息无法进行查看，且不支持注销，请在封禁页面优先进行账号解封申诉。</p>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
    <Service/>
  </div>
</template>

<script>
import Service from "./Service";
export default {
  name: 'Index',
  components: {Service},

  data() {
    return {
      activeNames: '',
    }
  },

  methods: {
    goAddPage(route) {
      this.$router.push(route);
    },
    handleSpanClick(value) {
      var basePath = "<%=basePath%>";
      var browser = {
        versions: function () {
          var u = navigator.userAgent, app = navigator.appVersion;
          return {//移动终端浏览器版本信息
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
          };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
      };

      // 调用浏览器版本信息判断是IOS还是Android
      if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
        window.webkit.messageHandlers.WebToiOS.postMessage(value);
      } else {
        this.showInfoFromJs(value);
      }
    },
    showInfoFromJs(value) {
      return window.AndroidWebView.showInfoFromJs(value);
    },
  }
}
</script>


<style scoped>

.icon-top {
  width: 100%;
  height: 143px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.icon-item {
  width: 80px;
  height: 102px;
  border-radius: 8px;
}

.hr {
  height: 12px;
  width: 100%;
  background: #F9FAFC;
}

.content {
  width: 100%;
}

.content-title {
  margin-top: 20px;
  margin-left: 13px;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
}


/deep/ .van-cell {
  color: #666666;
}

/deep/ .van-icon-circle2 {
  color: #3576F9;
}

/deep/ .van-icon-circle {
  color: #E6E5E5;
}

/deep/ .checked-title {
  font-size: 15px;
  color: #000000 !important;
}
/deep/ .unchecked {
  font-size: 15px;
}

.item-content {
  font-size: 12px;
  color: #333333;
  line-height: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

.item-title {
  font-weight: 600;
}

.key-text{
  font-weight: 500;
  color: #4C30FC;
}

.item-img{
  width: 100%;
  text-align: center;
  margin-top: 30px;
}

/*.page {
  background-image: url("../assets/img/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}*/
.customer-service {
  position: fixed;
  bottom: 30px;
  left: 80%;
  transform: translateX(-50%);
  width: 60px;
  height: 60px;
}

.customer-service img {
  width: 100%;
  height: 100%;
}

.red-text {
  color: red;
}

.blue-text {
  color: cornflowerblue;
}
.main-container{
  z-index: 999;
  position: relative;
  background-color: #f5f7fb;
  padding: 18px 18px 14px 18px;
}
.content .content-topic:last-child{
  margin-bottom: 70px;
}
.content-topic{
  padding: 0 13px;
  background-color: #ffffff;
  border-radius: 10px;
}
.content-topic .el-collapse {
  border-top: none;
  border-bottom: none;
}
.content-topic .el-collapse-item__header {
  font-size: 15px;
}
.content-topic .last .el-collapse-item__header {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/page/Account.vue